<meta-title i18n>איפוס סיסמה שנשכחה</meta-title>

<div class="auth-page">
  <ui-error [state]="loadState"></ui-error>

  <header class="auth-page-header">
    <h2 i18n>סיסמה חדשה למייל</h2>
  </header>

  <div class="auth-card">
    <form [formGroup]="form" novalidate autocomplete="off" (submit)="identify()">
      <identity-key-field [form]="form" [loadState]="loadState">
        <p identityKeyHint class="auth-hint" i18n>
          עליך לוודא ש{method, select, idNumber {תעודת הזהות} passport {מספר הדרכון}} שלך ולא של משהו אחר
        </p>
      </identity-key-field>

      <div class="auth-form-actions auth-form-actions--row">
        <a routerLink="/start" class="auth-secondary-btn auth-secondary-btn--link" i18n> חזרה להתחברות </a>

        <ui-progress-button
          class="auth-submit"
          color="primary"
          [disabled]="form.invalid || !loadState.isCompleted"
          [state]="identifyState"
          i18n
        >
          {identifyState.value, select, inProcess {מאפס את הסיסמה שלך} other {אפס את הסיסמה שלי}}
        </ui-progress-button>
      </div>

      <div class="auth-alert" *visible="identifyState.error?.isInvalidModel" i18n>
        {method, select, idNumber {תעודת הזהות שהזנת אינה תקינה} passport {מספר הדרכון שהזנת אינו תקין}}
      </div>

      <div class="auth-alert auth-alert--info" *visible="identifyState.error?.isEntityNotExists" i18n>
        מצטערים, אבל איננו מזהים אותך במערכת שלנו. בחרו בכניסה למערכת לצורך זיהוי מחדש.
      </div>

      <ui-error [state]="identifyState" [ignoreList]="[400, 404]"></ui-error>
    </form>
  </div>
</div>
